import { useModuleBEM } from "@b2bportal/core-themes";
import clsx from "clsx";
import tabStyles from "../Tab.module.scss";
import styles from "./FolderTabs.module.scss";
import { scrollToElement } from "@/utils/scroll";

export type NavigationTabOption = {
  label: string;
  href: string;
};

interface NavigationTabsProps {
  options: NavigationTabOption[];
  activeHref?: string;
  tabClassName?: string;
}

export const NavigationTabs = ({
  options,
  activeHref,
  tabClassName,
}: NavigationTabsProps) => {
  const [block] = useModuleBEM(styles, "FolderTabs");

  return (
    <div className={block}>
      {options.map((option) => (
        <NavigationTab
          key={option.href}
          label={option.label}
          href={option.href}
          active={activeHref === option.href}
          className={tabClassName}
        />
      ))}
    </div>
  );
};

interface NavigationTabProps {
  label: string;
  href: string;
  active?: boolean;
  className?: string;
}

const NavigationTab = ({
  label,
  href,
  active,
  className,
}: NavigationTabProps) => {
  const [block, cn] = useModuleBEM(tabStyles, "Tab", { active });

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    const targetId = href.replace("#", "");
    scrollToElement(targetId);

    // Update URL without scrolling
    window.history.pushState(null, "", href);
  };

  return (
    <a className={clsx(block, className)} href={href} onClick={handleClick}>
      <span className={cn("label")}>{label}</span>
    </a>
  );
};
